module.exports = __webpack_public_path__ + "img/pg.5527cb1c.svg";